import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import "./assets/font/iconfont.css";
import "./style/global.scss";
import { Boot } from '@wangeditor/editor'
import mitt from "./mitt";

const app = createApp(App)

class MyButtonMenu {
  constructor() {
    this.title = '评论'
    this.tag = 'button'
  }
  getValue() { return '' }
  isActive() { return false }
  isDisabled(editor) {
    const selection = editor.selection
    return !selection || selection.isCollapsed
  }
  exec(editor) {
     let savedSelectionRef = editor.selection 
    if (savedSelectionRef?.anchor.offset !== savedSelectionRef?.focus.offset) {
      mitt.emit("updatePzVisible");
    }
  }
}

Boot.registerMenu({
  key: 'my-menu-1',
  factory() {
    return new MyButtonMenu()
  },
})

app.use(router).use(ElementPlus).mount('#app')
